import React from 'react'

function SvgVideoRecorder(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
        d="M18.333 7.443c0-.505 0-.757-.1-.874a.417.417 0 00-.35-.145c-.153.012-.331.19-.688.547L14.166 10l3.029 3.029c.357.357.535.535.688.547a.417.417 0 00.35-.145c.1-.116.1-.369.1-.874V7.443zM1.666 8.167c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093c.535-.272 1.235-.272 2.635-.272h4.5c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093c.273.534.273 1.235.273 2.635v3.666c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 01-1.092 1.093c-.535.272-1.235.272-2.635.272h-4.5c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 01-1.093-1.093c-.272-.534-.272-1.235-.272-2.635V8.167z"
      ></path>
    </svg>
  )
}

export default SvgVideoRecorder
